exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mini-layout #launch-btn[data-v-36bdfb46] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  opacity: 0;\n  overflow: hidden;\n}\n.mini-layout #launch-btn .btn[data-v-36bdfb46] {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n}\n", ""]);

// exports
